/**
 * Accessible (WCAG 2.2 AA) tool color palette.
 *
 * Each index maps 1-to-1 with the original toolPalette in toolColors.js.
 * Secondary colors are collapsed to the darkest row per Jess's color guide.
 * Primary colors use the accessible replacements from the Color Palette PDFs.
 * Background/border colors (index 34+) are unchanged.
 */
const toolPaletteA11y = [
  '#1f7496', //  0  #38B8E0 → teal (darkest)
  '#3E4612', //  1  #A8BC3B → yellow-green (darkest)
  '#95610b', //  2  #FDB833 → yellow/brown (darkest)
  '#CC3000', //  3  #F46300 → orange (darkest)
  '#89043D', //  4  #CA1551 → red (darkest)
  '#AB259E', //  5  #F57EDA → magenta (darkest)
  '#8407E5', //  6  #B75EFF → purple (darkest)
  '#2121CE', //  7  #5C5CEA → blue (darkest)
  '#1f7496', //  8  #227EA3 → teal (already darkest)
  '#3E4612', //  9  #707D28 → yellow-green (darkest)
  '#95610b', // 10  #B1740F → yellow/brown (darkest)
  '#CC3000', // 11  #CC3000 → orange (already darkest)
  '#89043D', // 12  #89043D → red (already darkest)
  '#AB259E', // 13  #EA36D9 → magenta (darkest)
  '#8407E5', // 14  #8407E5 → purple (already darkest)
  '#2121CE', // 15  #2121CE → blue (already darkest)
  '#1f7496', // 16  #81D7EA → teal (darkest)
  '#3E4612', // 17  #CAD142 → yellow-green (darkest)
  '#95610b', // 18  #F7CD00 → yellow/brown (darkest)
  '#CC3000', // 19  #FF915D → orange (darkest)
  '#89043D', // 20  #E82E81 → red (darkest)
  '#AB259E', // 21  #F49DCB → magenta (darkest)
  '#8407E5', // 22  #D99BF9 → purple (darkest)
  '#2121CE', // 23  #9098FC → blue (darkest)
  '#067B87', // 24  #0FC5D8 → accessible hyperlink
  '#1e7b4c', // 25  #37CC82 → accessible entrepreneur green
  '#426EBB', // 26  #5185E0 → accessible mentor blue
  '#1f7496', // 27  #4C91B9 → teal (darkest)
  '#067B87', // 28  #1E9296 → accessible hyperlink (teal family)
  '#89043D', // 29  #AF0E46 → red (darkest)
  '#426EBB', // 30  #71A0E2 → accessible mentor blue
  '#1e7b4c', // 31  #85E0B0 → accessible entrepreneur green
  '#CC3000', // 32  #E5243B → orange/red (darkest)
  '#95610b', // 33  #DDA63A → yellow/brown (darkest)
  '#F2F2F2', // 34  #F2F2F2 → background (unchanged)
  '#6F6F6F', // 35  #999999 → accessible grey
  '#FFF8ED', // 36  #FFF8ED → light bg (unchanged)
  '#EDF8FC', // 37  #EDF8FC → light bg (unchanged)
  '#123DC6', // 38  #123DC6 → main blue (already passes)
  '#426EBB', // 39  #8fa2e2 → accessible mentor blue
  '#D0D8F4', // 40  #D0D8F4 → light bg (unchanged)
  '#E7EBF9', // 41  #E7EBF9 → light bg (unchanged)
  '#1F1F1F', // 42  #1F1F1F → dark (unchanged)
  '#D9D9D9', // 43  #D9D9D9 → border (unchanged)
];

export default toolPaletteA11y;
